import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_lots_by_lotIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lotIds?: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string }, Status?: { Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lotIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string }, Status?: { Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lotIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string }, Status?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lotIds?: number[]    }) {
      return false;
    }
}
